import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import useCartStore from "../Stores/CartStore";
import axios from "axios";
import { Slide, toast } from "react-toastify";
import { IoBagCheckSharp } from "react-icons/io5";
import BtnLoading from "../Components/BtnLoading";

const CheckoutPage = () => {
  const [disabled, setDisabled] = useState(false);

  const { items, clearCart } = useCartStore((state) => ({
    items: state.items,
    clearCart: state.clearCart,
  }));

  const [formData, setFormData] = useState({
    customer_name: "",
    customer_phone: "",
    alternative_phone: "",
    state: "",
    address: "",
  });

  const [shippingCost, setShippingCost] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [orderId, setOrderId] = useState(0);

  const provinces = [
    { name: "القاهرة", shippingCost: 50 },
    { name: "الجيزة", shippingCost: 50 },
    { name: "القليوبية", shippingCost: 50 },
    { name: "الاسكندرية", shippingCost: 60 },
    { name: "الغربية", shippingCost: 60 },
    { name: "كفر الشيخ", shippingCost: 60 },
    { name: "المنوفية", shippingCost: 60 },
    { name: "الشرقية", shippingCost: 60 },
    { name: "الدقهلية", shippingCost: 60 },
    { name: "الدمياط", shippingCost: 60 },
    { name: "الغربية", shippingCost: 60 },
    { name: "البحيرة", shippingCost: 60 },
    { name: "الفيوم", shippingCost: 60 },
    { name: "الغردقة", shippingCost: 60 },
    { name: "اسماعيلية", shippingCost: 60 },
    { name: "السويس", shippingCost: 60 },
    { name: "المنيا", shippingCost: 70 },
    { name: "قنا", shippingCost: 70 },
    { name: "الأقصر", shippingCost: 70 },
    { name: "سوهاج", shippingCost: 70 },
    { name: "اسيوط", shippingCost: 70 },
    { name: "أسوان", shippingCost: 70 },
    { name: "بني سويف", shippingCost: 60 },
    { name: "الوادي الجديد", shippingCost: 70 },
    { name: "البحر الاحمر", shippingCost: 70 },
    { name: "بورسعيد", shippingCost: 60 },
    // أضف بقية المحافظات هنا
  ];
  


  useEffect(() => {
    if (items.length > 0) {
      const total = items.reduce(
        (acc, item) => acc + parseFloat(item.price),
        0
      );
      setTotalAmount(total);

      if (formData.state) {
        const province = provinces.find((p) => p.name === formData.state);
        if (province) {
          setShippingCost(province.shippingCost);
        }
      }
    }
  }, [items, formData.state]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    setDisabled(true);
    e.preventDefault();

    const orderItems = items.map((item) => ({
      product_id: item.productId,
      offer_id: item.offerId || null,
      quantity: item.quantity,
      items: item.options.map((option) => ({
        color: option.color.label,
        size: option.size.label,
      })),
    }));

    const orderData = {
      customer_name: formData.customer_name,
      customer_phone: formData.customer_phone,
      alternative_phone: formData.alternative_phone,
      state: formData.state,
      address: formData.address,
      shipping_cost: shippingCost,
      total_amount: totalAmount + shippingCost,
      order_items: orderItems,
    };

    try {
      const response = await axios.post("/checkout", orderData);
      console.log("Order response:", response.data);
      clearCart();
      toast.success("تم عمل الطلب بنجاح !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Slide,
      });
      setOrderId(response.data.order.id);
      setOrderSuccess(true);
    } catch (error) {
      console.error("Error submitting order:", error);
      alert("حدث خطأ أثناء إتمام الطلب. حاول مرة أخرى او تواصل معنا");
    }
  };

  if (orderSuccess) {
    return (
      <>

      <div className="shadow p-4 text-2xl flex flex-col gap-3 items-center mt-7 font-semibold">
        <IoBagCheckSharp className="text-green-500 text-6xl" />
        <h2>تم استلام الطلب بنجاح</h2>
        <h2>رقم الطلب : {orderId}</h2>
        <Link to='/' className="bg-blue-500 p-3 mt-5 rounded text-lg text-white">شوف منتجات تانيه</Link>
      </div>
      </>
    );
  }

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-4 text-center">إتمام الطلب</h1>
      {items.length === 0 ? (
        <p className="text-center">السلة فارغة، لا يمكن إتمام الطلب.</p>
      ) : (
        <div className="flex flex-col md:flex-row gap-6">
          {/* نموذج إدخال بيانات المستخدم */}
          <div className="w-full md:w-1/2">
            <form
              onSubmit={handleSubmit}
              className="p-6 bg-white border border-gray-300 rounded shadow-md"
            >
              <h2 className="text-2xl font-bold mb-4">معلومات الشحن</h2>
              <div className="mb-4">
                <label
                  htmlFor="customer_name"
                  className="block text-lg font-semibold mb-2"
                >
                  الاسم الكامل
                </label>
                <input
                  type="text"
                  id="customer_name"
                  name="customer_name"
                  value={formData.customer_name}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded"
                  required
                />
              </div>
              <div className="mb-4">
                <label
                  htmlFor="customer_phone"
                  className="block text-lg font-semibold mb-2"
                >
                  رقم الهاتف
                </label>
                <input
                  type="text"
                  id="customer_phone"
                  name="customer_phone"
                  value={formData.customer_phone}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded"
                  required
                />
              </div>
              <div className="mb-4">
                <label
                  htmlFor="alternative_phone"
                  className="block text-lg font-semibold mb-2"
                >
                  رقم هاتف احتياطي (اختياري)
                </label>
                <input
                  type="text"
                  id="alternative_phone"
                  name="alternative_phone"
                  value={formData.alternative_phone}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>
              <div className="mb-4">
                <label
                  htmlFor="state"
                  className="block text-lg font-semibold mb-2"
                >
                  المحافظة
                </label>
                <select
                  id="state"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded"
                  required
                >
                  <option value="">اختر المحافظة</option>
                  {provinces.map((province, index) => (
                    <option key={index} value={province.name}>
                      {province.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-4">
                <label
                  htmlFor="address"
                  className="block text-lg font-semibold mb-2"
                >
                  العنوان تفصيلي
                </label>
                <textarea
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded"
                  required
                />
              </div>
              <button
                type="submit"
                disabled={disabled}
                className="w-full p-2 bg-green-500 text-white rounded disableBtn hover:bg-green-600 transition"
              >
                إتمام الطلب
                {disabled && <BtnLoading />}
              </button>
            </form>
          </div>

          {/* تفاصيل السلة وملخص الطلب */}
          <div className="w-full md:w-1/2">
            <div className="p-6 bg-white border border-gray-300 rounded shadow-md">
              <div className="mt-6 p-4 border border-gray-300 rounded font-bold">
                <h2 className="text-xl font-bold mb-2">ملخص الطلب</h2>
                <p>سعر الشحن: {shippingCost} جنيه</p>
                <p>إجمالي الطلب: {totalAmount + shippingCost} جنيه</p>
              </div>
              <h2 className="text-2xl font-bold my-4">تفاصيل الطلب</h2>
              <ul>
                {items.map((item, index) => (
                  <li
                    key={index}
                    className="mb-4 p-4 border border-gray-300 rounded"
                  >
                    <h3 className="text-xl font-semibold">
                      {item.productName}
                    </h3>
                    <p>
                      العرض: {item.quantity} قطعة بـ {item.price} جنيه
                    </p>
                    <div className="mt-4">
                      {item.options.map((option, optionIndex) => (
                        <div
                          key={optionIndex}
                          className="p-4 border border-gray-200 rounded mb-2"
                        >
                          <p className="font-semibold">
                            القطعة {optionIndex + 1}
                          </p>
                          <p>اللون: {option.color.label || "غير محدد"}</p>
                          <p>المقاس: {option.size.label || "غير محدد"}</p>
                          <p>العدد: {option.quantity}</p>
                        </div>
                      ))}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckoutPage;
